import React from 'react';
import SystemBoundaryGridPdf from 'components/v2/compiler/grids/system-boundary/SystemBoundaryGridPdf';
import DebugOnly from 'util/dev-tools/DebugOnly';
import RenderCounter from 'util/dev-tools/RenderCounter';
import { PdfH1, PdfPage, PdfTable, PdfThLabel } from './Styles.styled';
import usePcrV2 from 'components/v2/compiler/hooks/usePcrV2';
import { EPD_DICTIONARY_CODES } from 'services/api/constants';
import usePdfData from './utils/usePdfData';

const SystemBoundaryPage: React.FC = () => {
  const { epdVersionId, epdDefinition, systemBoundary, dictionaryValues } = usePdfData();
  const isPcrV2 = usePcrV2();

  const descriptionDictionaryCode = isPcrV2
    ? EPD_DICTIONARY_CODES.SYSTEM_BOUNDARY_DESCRIPTION_V2
    : EPD_DICTIONARY_CODES.SYSTEM_BOUNDARY_DESCRIPTION;

  const systemBoundaryHasExcludedModulesLookup = [
    { value: true, label: 'Yes, there is an excluded module, or there are excluded modules' },
    { value: false, label: 'No, there is no excluded module, or there are no excluded modules' },
  ];

  return (
    <PdfPage className="landscape">
      <DebugOnly>
        <RenderCounter componentName="SystemBoundary" threshold={3} />
      </DebugOnly>
      <PdfH1>System boundary</PdfH1>
      <PdfTable style={{ marginBottom: '1rem' }}>
        <thead>
          <tr>
            <PdfThLabel />
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Description of the System boundary</td>
            <td>
              {
                dictionaryValues.find(
                  (x) => x.dictionaryCode === descriptionDictionaryCode && x.key === systemBoundary?.description
                )?.value
              }
            </td>
          </tr>
          <tr>
            <td>Excluded modules</td>
            <td>
              {systemBoundaryHasExcludedModulesLookup.find((x) => x.value == systemBoundary?.hasExcludedModules)?.label}
            </td>
          </tr>
          {systemBoundary?.hasExcludedModules && (
            <tr>
              <td>Justification for omission of modules</td>
              <td>{systemBoundary?.excludedModulesJustification}</td>
            </tr>
          )}
        </tbody>
      </PdfTable>
      <SystemBoundaryGridPdf epdVersionId={epdVersionId} productType={epdDefinition.productType} dontApplyPrintStyles />
    </PdfPage>
  );
};

export default SystemBoundaryPage;
